// extracted by mini-css-extract-plugin
module.exports = {"cardsContent":"styles_cardsContent__2QZFN","title":"styles_title__3AB5R","subTitle":"styles_subTitle__2Lg7y","cardsSection":"styles_cardsSection__3iYT1"};